import styled, { css } from 'styled-components';
import { CardProps } from './types';
import {
	DEFAULT_BG_COLOR,
	DISABLED_COLOR,
	INFO_COLOR,
	MAIN_BG_COLOR,
	MAIN_TEXT_COLOR,
	SECONDARY_BG_COLOR,
} from 'shared/consts';

const getVariant = (variant?: string) => {
	if (!variant) {
		return DEFAULT_BG_COLOR;
	}

	switch (variant) {
		case 'main':
			return SECONDARY_BG_COLOR;
		case 'secondary':
			return MAIN_BG_COLOR;
		case 'disabled':
			return DISABLED_COLOR;
		case 'info':
			return INFO_COLOR;
		case 'default':
			return DEFAULT_BG_COLOR;
		case 'transparent':
			return 'transparent';
		case 'bordered':
			return MAIN_TEXT_COLOR;
		default:
			return DEFAULT_BG_COLOR;
	}
};

export const Card = styled.div<CardProps>`
	${props =>
		!props.$show &&
		css`
			display: none;
		`}

	${props =>
		props.$isRoundedCorners &&
		css`
			border-radius: ${props.$borderRadius || '24px'};
		`}

	
	border: 1px solid ${props => props.$border || getVariant(props.$variant)};
	box-sizing: border-box;

	${props =>
		props.$border &&
		css`
			border-radius: ${props.$borderRadius || '24px'};
		`}

	${props =>
		props.$borderTopLeftRadius &&
		css`
			border-top-left-radius: ${props.$borderTopLeftRadius};
		`}
	${props =>
		props.$borderTopRightRadius &&
		css`
			border-top-right-radius: ${props.$borderTopRightRadius};
		`}

	padding: ${props => props.$padding || 'initial'};

	width: ${props => (props.$fitContent ? 'fit-content' : 'initial')};
  ${props => {
    if (props.$bg) {
      return `
        background: ${props.$bg};
        color: #fff;
      `
    }
    return `background: ${getVariant(props.$variant)};`
  }}
`;
